import React, { useEffect, useState, useRef } from "react";
import Navbar from "react-bootstrap/Navbar";
import { Stack } from "react-bootstrap";
import { useIsAuthenticated } from "@azure/msal-react";
import { SignInButton } from "../components/SignInButton";
import { SignOutButton } from "../components/SignOutButton";
import axios from "../configuration/axios";
import { useMsal } from "@azure/msal-react";
import { UserCard } from "../components/UserCard";
import { CreateUserDialog } from "../components/CreateUserDialog";
import { Text } from "@fluentui/react";
import { UserConfirmationPopUp } from "../components/UserConfirmationPopUp";
import { ExpiredTokenPopup } from "../components/ExpiredTokenPopup";

function UserManagementPage(props) {
  const { setTokenExpired, tokenExpired, hasAdminSignedInAndSubscription } =
    props;
  const { instance, accounts, inProgress } = useMsal();
  const isAuthenticated = useIsAuthenticated();
  const [isActivating, setIsActivating] = useState(false);
  const [selectedCountry, setSelectedCountry] = useState(null);
  const [isProvisioned, setIsProvisioned] = useState(false);
  const [userSignedIn, setUserSignedIn] = useState(false);
  const [usersState, setUsersState] = useState([]);
  const [subscriptionId, setSubscriptionId] = useState(null);
  const [popUp, setPopUp] = useState(false);
  const [toDeleteUserId, setToDeleteUserId] = useState(-1);
  const [toDeleteUserGuid, setToDeleteUserGuid] = useState(-1);
  let authMsalToken = localStorage.getItem("msalToken");

  //TODO: save subscription id in storage and use for checking users and creating users etc.... but already do that in main rather, after login.
  useEffect(async () => {
    await getUserList();
  }, [usersState.length > 0, subscriptionId, accounts.length > 0]);

  function addUserToList(userToAdd) {
    const newUsersState = [...usersState];
    newUsersState.push(userToAdd);
    setUsersState(newUsersState);
  }

  function setIsAdmin(userGuid, isAdmin) {
    const newUsersState = [...usersState];
    var currentUser = newUsersState.find(x => x.userGuid === userGuid);
    currentUser.isAdmin = isAdmin;
    setUsersState(newUsersState);
  }

  async function getUserList() {
    if (accounts.length > 0) {
      var resultData;
      var tenantId = accounts[0].tenantId;
      const config = {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("msalToken")}`,
        },
      };
      axios.defaults.headers.common["Authorization"] =
        "Bearer " + localStorage.getItem("msalToken");

      await axios
        .get(
          axios.defaults.baseURL + "/Subscription/GetByTenantId",
          {
            params: { tenantId: tenantId },
          },
          config
        )
        .then((result) => {
          setTokenExpired(false);
          setSubscriptionId(result.data.id);
          resultData = result.data;
        })
        .catch((error) => {
          if (error.response.status === 401) {
            setTokenExpired(true);
          }
        });
      await getLicenseManagerList(resultData);
    }
  }

  async function removeUserById(userId) {
    const config = {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("msalToken")}`,
      },
    };
    var resData;
    await axios
      .delete(
        axios.defaults.baseURL + "/LicenseManager/RemoveById",
        { params: { userId: toDeleteUserGuid } },
        config
      )
      .then((result) => {
        setTokenExpired(false);
        removeUser(toDeleteUserGuid);
      })
      .catch((error) => {
        if (error.response.status === 401) {
          setTokenExpired(true);
        }
      });
  }

  async function getLicenseManagerList(resultData) {
    const config = {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("msalToken")}`,
      },
    };
    var resData;
    await axios
      .get(
        axios.defaults.baseURL+ "/LicenseManager/BySubscriptionId",
        { params: { subscriptionId: resultData && resultData.id ? resultData.id : null } },
        config
      )
      .then((result) => {
        setTokenExpired(false);
        setUsersState(result.data);
      })
      .catch((error) => {
        if (error.response.status === 401) {
          setTokenExpired(true);
        }
      });
  }

  async function removeUser(userGuid) {
    var newUsersList = [...usersState];
    for (var i = newUsersList.length - 1; i >= 0; i--) {
      if (newUsersList[i].userGuid === userGuid) {
        newUsersList.splice(i, 1);
      }
    }
    setUsersState(newUsersList);
  }

  return (
    <div style={{ overflow: "hidden" }}>
      {tokenExpired && isAuthenticated ? <ExpiredTokenPopup setTokenExpired={setTokenExpired} />: null}
      <Navbar
        style={{
          paddingTop: "1vh",
          paddingBottom: "1vh",
          justifyContent: "left",
          borderBottom: "2px",
          borderColor: "black",
          backgroundColor: "#0066CC",
        }}
        variant="dark"
      >
        <a className="navbar-brand" href="/" style={{ marginLeft: "1rem" }}>
          novaCapta Compass Subscription Management
        </a>
        {isAuthenticated ? (
          <SignOutButton setTokenExpired={setTokenExpired} />
        ) : (
          <SignInButton setUserSignedIn={setUserSignedIn} />
        )}
      </Navbar>
      {hasAdminSignedInAndSubscription ? (
        <div style={{ marginLeft: "3rem", height: "90vh" }}>
          <h5 style={{ marginTop: "2vh" }}>
            <h1 style={{ fontSize: "4vh" }}>User Management</h1>
            <CreateUserDialog
            setTokenExpired={setTokenExpired}
              addUserToList={addUserToList}
              subscriptionId={subscriptionId}
            />
            <Stack
              style={{ overflowY: "scroll", marginTop: "2vh", height: "77vh" }}
            >
              {usersState.map(function (user) {
                return (
                  <div>
                    <UserCard
                      userName={user.userName}
                      userEmail={user.userEmail}
                      isAdmin={user.isAdmin}
                      setIsAdmin={setIsAdmin}
                      isActive={user.isActive}
                      isSuperAdmin={user.superAdmin}
                      removeUser={removeUser}
                      userGuid={user.userGuid}
                      popUp={popUp}
                      setPopUp={setPopUp}
                      subscriptionId={subscriptionId}
                      setTokenExpired={setTokenExpired}
                      setUsersState={setUsersState}
                      setToDeleteUserId={setToDeleteUserId}
                      setToDeleteUserGuid={setToDeleteUserGuid}
                    />
                  </div>
                );
              })}
            </Stack>
          </h5>
        </div>
      ) : null}
      <Navbar
        style={{
          justifyContent: "center",
          position: "absolute",
          bottom: "0",
          width: "100%",
          borderColor: "black",
          backgroundColor: "#0066CC",
        }}
        variant="dark"
      >
        <Text style={{ color: "white" }}>©2021 novaCapta GmbH</Text>
      </Navbar>
      {popUp ? (
        <UserConfirmationPopUp
          setPopUp={setPopUp}
          removeUserById={removeUserById}
          toDeleteUserId={toDeleteUserId}
        />
      ) : null}
    </div>
  );
}

export default UserManagementPage;
